<template lang="pug">
  button(
    :id="action.key"
    class="e-toolbar-button"
    :class="{ active: action.isActive }"
    data-toolbar="button"
    v-on="listeners"
    @click.prevent="action.call"
  )
    e-svg-icon(
      :name="action.icon"
      size="xmd"
    )
</template>

<script>
export default {
  name: 'EToolbarButton',
  props: {
    action: {
      type: Object,
      default: () => ({})
    },
    listeners: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<style scoped lang="scss">
.e-toolbar-button {
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;

  &.active {
    border-radius: 8px;
    background: #454545;
  }
}
</style>
